<template>
  <div class="photo-prescription">
    <h2 class="is-print-hide title-area">
      <span class="main-title">申请处方</span>
    </h2>
    <breadcrumb firstName="申请处方" :secondName="secondName"></breadcrumb>
    <el-card class="content">
      <take-picture v-if="takePictureShow" @getImageUrl="getImageUrl"></take-picture>
      <upload-picture v-if="uploadPictureShow" @getImageUrl="getImageUrl"></upload-picture>
      <pre-sign-preview
        v-if="signPreviewShow"
        :width="A5_W"
        :height="A5_H"
        :imageSrc="originPrescription"
        :cancelText="photoType == TAKE ? '重拍' : '重选图片'"
        @onSubmit="submit"
        @onDragStop="getImgParam"
        @onCancel="initData"
      ></pre-sign-preview>
      <apply-success v-if="applyStage === 3" @onContinue="initData"></apply-success>
    </el-card>
  </div>
</template>
<script>
import breadcrumb from '@/components/global/breadcrumb';
import { PHOTO_TYPE, photoTypeName, A5_W, A5_H } from '@/lib/constant';
import takePicture from './components/takePicture';
import uploadPicture from './components/uploadPicture';
import preSignPreview from './components/preSignPreview';
import applySuccess from './components/applySuccess';
import Fetch from '@/api';
export default {
  name: 'photoPrescription',
  components: { breadcrumb, takePicture, uploadPicture, preSignPreview, applySuccess },
  data() {
    return {
      ...PHOTO_TYPE,
      A5_W,
      A5_H,
      secondName: '',
      photoType: 2, //默认是上传图片防止是高拍仪，加载高拍仪组件，高拍仪组件里面有一些初始进入的请求
      originPrescription: '', //初始的处方图片
      prescriptionImageFile: '',
      applySuccess: false,
      imgParam: ''
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const { photoType } = to.params;
      vm.photoType = photoType;
      vm.secondName = photoTypeName[photoType];
    });
  },
  computed: {
    // 高拍仪拍摄是否展示
    takePictureShow() {
      const { applyStage, photoType, TAKE } = this;
      return photoType == TAKE && applyStage == 1;
    },
    // 上传图片拍摄是否展示
    uploadPictureShow() {
      const { applyStage, photoType, UPLOAD } = this;
      return photoType == UPLOAD && applyStage == 1;
    },
    // 有处方图以后，预览签名位置是否展示
    signPreviewShow() {
      const { applyStage } = this;
      return applyStage == 2;
    },
    // 申请阶段
    applyStage() {
      const { originPrescription, applySuccess } = this;
      if (!applySuccess && originPrescription) return 2;
      if (applySuccess) return 3;
      return 1;
    }
  },
  methods: {
    // 获取图片url
    getImageUrl(file) {
      // 获取blob地址，防止base64过长，在性能不好的电脑上面，发起请求会出现问题
      let objUrl = URL.createObjectURL(file);
      this.originPrescription = objUrl;
    },
    initData() {
      this.originPrescription = '';
      this.prescriptionImageFile = '';
      this.applySuccess = false;
    },
    getImgParam({ x, y }) {
      const x_p = parseFloat(x / A5_W).toFixed(3);
      const y_p = parseFloat(y / A5_H).toFixed(3);
      this.imgParam = `${x_p},${y_p},0`;
    },
    async submit(file) {
      const {
        data: { url }
      } = await this.uploadFile(file);
      await Fetch.apply_photo_prescription({ photoUrl: url, imgParam: this.imgParam, applySource: 1 });
      this.initData();
      this.applySuccess = true;
    },
    uploadFile(file) {
      return new Promise((resolve, reject) => {
        if (!window.FormData) {
          this.$message.error('您当前浏览器不支持图片上传，请更换为360极速浏览器');
          return;
        }
        let fd = new FormData();
        fd.append(
          'uploadParam',
          JSON.stringify({ appName: 'drugstore-prescription-admin-pc', scene: 'prescription_file' })
        );
        fd.append('fileStream', file);
        Fetch.uploadImage(fd)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.photo-prescription {
  .content {
    min-height: calc(100vh - 190px);
  }
}
</style>
